import React, { ReactNode } from 'react';
import { WprButton } from '../../wpr-framework/component/controls/WprButton';
import { WprContainer } from '../../wpr-framework/component/controls/WprContainer';
import { withRouter } from 'react-router';
import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import { ConfirmComponentView, selectCompensationIdx, deathCompensationExists} from './ConfirmComponentView';
import { WprRowInfo } from '../../wpr-framework/component/props/WprRowInfo';
import { WprSpan } from '../../wpr-framework/component/controls/WprSpan';
import { WprCheckBox } from '../../wpr-framework/component/controls/WprCheckBox';
import { HeaderComponent } from '../common/header/HeaderComponent';
import { FooterComponent } from '../common/footer/FooterComponent';
import { WprAnchor } from '../../wpr-framework/component/controls/WprAnchor';

/**
 * 登録情報確認コンポーネント
 */
class ConfirmComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new ConfirmComponentView(), props);
	}

	public handleClick = (e: React.MouseEvent, props) => {
		e.nativeEvent.stopImmediatePropagation();
		const targetId = e.currentTarget.id;
		$('#' + targetId.replace('-lbl', '')).off('click');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		return (
			<>
				<HeaderComponent />
				<div className="step">
					<div className="wrap">
						<div className="stepper">
							<ul>
								<li className="done"><span>5</span></li>
								<li className="now"><span>6</span>
									<p className="conf" id="step6">申込内容の確認</p>
								</li>
								<li className=""><span>7</span></li>
								<li className=""><span>8</span></li>
							</ul>
						</div>

					</div>
				</div>
				<div className="page-confirm">
					<div className="top">
						<h1>保険プランの内容やお客様の<br />情報をご確認ください</h1>
					</div>
					<section className="basic-info">
						<h2 className="c-headline">基本情報</h2>
						<p><WprSpan name='explanation' view={this.view}></WprSpan></p>
						<div className="wrap-info c-list">
							<dl>
								<dt>保険種類</dt>
								<dd><WprSpan name='insuranceType' view={this.view}></WprSpan></dd>
							</dl>
							<dl>
								<dt>契約プラン</dt>
								<dd><WprSpan name='plan' view={this.view}></WprSpan></dd>
							</dl>
							<dl>
								<dt>合計保険料（全員分）</dt>
								<dd><WprSpan name='insuranceFee' view={this.view} converter='3桁カンマ'></WprSpan>円</dd>
							</dl>
							<dl>
								<dt>保険期間</dt>
								<dd><WprSpan name='insurancePeriod' view={this.view}></WprSpan></dd>
							</dl>
							<dl>
								<dt>申込日</dt>
								<dd><WprSpan name='applicationDate' view={this.view}></WprSpan></dd>
							</dl>
						</div>
						<div className="compensation c-list">
							<div className="c-tit">
								<h3>補償内容</h3>
							</div>
							{this.renderList('CollateralInfo')}
						</div>
						<div className="covenant c-list">
							<div className="c-tit">
								<h3>特約・約款</h3>
							</div>
							<div className="wrap-covenant">
								<p><WprSpan name='specialProvision' view={this.view}></WprSpan></p>
							</div>
						</div>
					</section>
					<section className="contract">
						<h2 className="c-headline">契約者（申込者）情報</h2>
						<div className="wrap-contract c-list">
							<dl>
								<dt>契約者名</dt>
								<dd><WprSpan name='lastNameContractor' view={this.view}></WprSpan>　<WprSpan name='firstNameContractor' view={this.view}></WprSpan></dd>
							</dl>
							<dl>
								<dt>契約者名（ローマ字）</dt>
								<dd><WprSpan name='romanLastNameContractor' view={this.view}></WprSpan>　<WprSpan name='romanFirstNameContractor' view={this.view}></WprSpan></dd>
							</dl>
							<dl>
								<dt>生年月日</dt>
								<dd><WprSpan name='yearContractor' view={this.view}></WprSpan>年<WprSpan name='monthContractor' view={this.view}></WprSpan>月<WprSpan name='dateContractor' view={this.view}></WprSpan>日</dd>
							</dl>
							<dl>
								<dt>性別</dt>
								<dd><WprSpan name='genderContractor' view={this.view} converter='性別'></WprSpan></dd>
							</dl>
							<dl>
								<dt>住所</dt>
								<dd className="address">〒<WprSpan name='postalCode' view={this.view} converter='郵便番号'></WprSpan>　<WprSpan name='prefecture' view={this.view}></WprSpan><WprSpan name='address1' view={this.view}></WprSpan>　<WprSpan name='address2' view={this.view}></WprSpan></dd>
							</dl>
							<dl>
								<dt>電話番号</dt>
								<dd><WprSpan name='tel' view={this.view}></WprSpan></dd>
							</dl>
							<dl>
								<dt>メールアドレス</dt>
								<dd><WprSpan name='mailAddress' view={this.view}></WprSpan></dd>
							</dl>
							<WprButton className="c-edit-button" name="edit" view={this.view}><span>契約者情報を修正する</span></WprButton>
						</div>

					</section>
					<section className="traveler">
						{this.renderList('TravelerInfo')}
					</section>
					<section className="import-ex">
						<h2 className="c-headline">重要事項説明書</h2>
						<div className="wrap-ex">
							<p>
								重要事項説明書・意向確認書をダウンロードいただき、
								<br className="c-pc-br" />
								ご契約前に必ずご一読のうえ、お申込み手続きに進んでください。
								{/* WRQ-2990_旅行保険　直扱販売のための対応 START */}
								<br/>
								なお、当社の引受基準により保険のお引き受けができない場合がございますので、
								<br/>
								あらかじめご了承ください。
								{/* WRQ-2990_旅行保険　直扱販売のための対応 END */}
							</p>
						</div>
						<div className="wrap-import">
							<WprButton className="c-pdf-button" name="pdf" view={this.view}>
								<div className="logo" />
								<span>PDF重要事項説明書</span>
							</WprButton>
							<p className="pdf-imp">※PDFファイルには意向確認書も含まれます</p>
						</div>
					</section>
					<section className="announce">
						<h2 className="c-headline">告知事項</h2>
						<div className="kokuchijikou">
							<div className="c-tit">
								<h3>下記内容をご確認ください</h3>
							</div>
							<ol>
								{this.renderList('ContractNoticeInfo')}
							</ol>
							<div className="imp">
								<div className="wrap">
									<p>*危険な仕事および運動については、「重要事項説明書」の注意喚起情報　告知義務・通知義務の項目をご覧ください。</p>
									<p> ☆★の項目は、ご契約に際して保険会社がおたずねする特に重要な事項（告知事項）。</p>
									<p>★印の項目は、ご契約後に変更が生じた際に保険会社にご連絡をいただく必要のある事項（通知事項）です。</p>
									<p>ご回答が事実と相違している場合には、保険契約を解除する場合や、保険金をお支払いできない場合がありますのでご注意ください。</p>
								</div>
							</div>
						</div>
						<div className="all-yes"><span>全て「はい」</span></div>
					</section>
					<section className="other">
						<h2 className="c-headline">その他</h2>
						<div className="wrap-annotation">
							<p>チューリッヒ保険会社御中</p>
							<p>次の項目について確認・同意の上、本保険プランに申込みます。</p>
							<ul>
								<li>普通保険約款、特約および[重要事項説明書（契約概要/注意喚起情報）]の内容</li>
								<li>重要事項説明書に記載の[申込内容チェックシート（意向確認書）]の内容</li>
								<li>この入力確認画面の記載事項は事実に相違がないこと</li>
								<li>この入力確認画面に記載の個人情報が取扱代理店および引受保険会社へ提供・通知され、引受保険会社にて保護・管理されること</li>
							</ul>
							<div className="app">
								<div className="c-checkbox">
									<WprCheckBox name="check" id="lb_yes" view={this.view} />
									<label htmlFor="lb_yes" id="lb_yes-lbl" onClick={e => this.handleClick(e, this.props)}>上記内容を確認・同意のうえ申込む</label>
								</div>
							</div>
							<div className="wrap-other">
								<dl>
									<dt>引受保険会社</dt>
									<dd><span>チューリッヒ保険会社</span></dd>
								</dl>
								<dl>
									<dt>取扱代理店</dt>
									<dd><WprSpan name='agency' view={this.view}></WprSpan></dd>
								</dl>
							</div>
						</div>
					</section>
					<div className="pay">
						<WprButton name="toNext" view={this.view}><span>保険料のお支払いへ進む</span></WprButton>
					</div>
					<div className="prev">
						<WprAnchor view={this.view} name="prev" className="c-btn-prev">
							<span>1つ前の画面に戻る</span>
						</WprAnchor>
					</div>
				</div>
				<FooterComponent />
			</>
		);
	}
	/**
		 * リスト描画
		 * @param listName リスト名
		 * @param rowInfo 行情報
		 */
	protected onRenderList(listName: string, rowInfo: WprRowInfo): any {
		if (listName === 'TravelerInfo') {
			return (
				<div key={rowInfo.index}>
					<div className="traveler01">
						<h2 className="c-headline">
							旅行者（記名被保険者）-{this.zenkaku(rowInfo.index + 1)} 情報
						</h2>
						<div className="wrap-traveler01 c-list">
							<dl>
								<dt>被保険者名（ローマ字）</dt><dd className="c-input">
									<WprSpan name='romanLastNameTraveler' view={this.view} row={rowInfo}></WprSpan>　<WprSpan name='romanFirstNameTraveler' view={this.view} row={rowInfo}></WprSpan>
								</dd>
							</dl>
							<dl>
								<dt>生年月日</dt>
								<dd>
									<WprSpan name='yearTraveler' view={this.view} row={rowInfo}></WprSpan>年<WprSpan name='monthTraveler' view={this.view} row={rowInfo}></WprSpan>月<WprSpan name='dateTraveler' view={this.view} row={rowInfo}></WprSpan>日
								</dd>
							</dl>
							<dl>
								<dt>性別</dt>
								<dd>
									<WprSpan name='genderTraveler' view={this.view} row={rowInfo} converter='性別'></WprSpan>
								</dd>
							</dl>
							{this.showRecipient()}
							<WprButton className="c-edit-button" name="listEdit" view={this.view} row={rowInfo}><span>旅行者情報を修正する</span></WprButton>
						</div>
					</div>
				</div>
			);
		}
		if (listName === 'ContractNoticeInfo') {
			return (
				<li key={rowInfo.index}>
					<WprSpan name="noticeMessage" view={this.view} row={rowInfo}></WprSpan>
				</li>
			);
		}
		if (listName === 'CollateralInfo') {
			return (
				<dl key={rowInfo.index}>
					<dt>
						<WprSpan name="collateralName" view={this.view} row={rowInfo}/>
						<WprButton className="c-quest-b" name="question" view={this.view} row={rowInfo}></WprButton>
					</dt>
					<dd><WprSpan name='collateralAmount' view={this.view} row={rowInfo}></WprSpan></dd>
					{this.showHelp(rowInfo.index, rowInfo)}
				</dl>
			);
		}
		return null;
	}
	// --------------------------------------------------------------------------

	// 数字の半角→全角変換
	private zenkaku(num: number) {
		return String(num).replace(/[0-9]/g, function (s: string) {
			return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
		});
	}
	/**
	 * 補償ヘルプモーダル表示
	 * @param index 
	 * @param rowInfo 
	 */
	private showHelp(index: number, rowInfo: any) {
		// if (selectCompensationIdx === null)
		// 	return '';
		// if (index !== Number(selectCompensationIdx))
		// 	return '';
		return (<WprContainer mode={rowInfo.rowData.collateralKey} view = { this.view } >
			<div className="c-layer">
				<div className="box" key={rowInfo.index}>
					<h1><WprSpan name="displayCollateralName" view={this.view} row={rowInfo} /></h1>
					<p><WprSpan name="collateralDescription" view={this.view} row={rowInfo} /></p>
					<WprButton className="button" name="close" view={this.view}>
						<span>閉じる</span>
					</WprButton>
				</div>
			</div>
		</WprContainer >);
	}
	/**
	 * 死亡保険受取人表示
	 * @param index 
	 * @param rowInfo 
	 */
	private showRecipient() {
		if (deathCompensationExists) {
			return (
				<dl>
					<dt>死亡保険金受取人</dt>
					<dd>
						<span>死亡保険受取人は、被保険者の法定相続人となります</span>
					</dd>
				</dl>);
		}
		else
			return '';
	}
}
export default withRouter(ConfirmComponent);